import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Show debug info
Pusher.logToConsole = false;

const echo = new Echo({
  broadcaster: 'reverb',
  key: process.env.REACT_APP_REVERB_APP_KEY || '',
  wsHost: process.env.REACT_APP_REVERB_HOST || '',
  wsPort: Number(process.env.REACT_APP_REVERB_PORT) || 8080,
  wssPort: Number(process.env.REACT_APP_REVERB_PORT) || 443,
  forceTLS: (process.env.REACT_APP_REVERB_SCHEME || 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  disableStats: true,
  encrypted: true,
  auth: {
    headers: {
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
    },
  },
});

export default echo;
